import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
export {
  StyledTypography
};
